import {Directive, ElementRef, Input, Renderer2} from "@angular/core";

@Directive({
  selector: '[nbStyle]'
})
export class NbStyleDirective {
  _css:string[]= [];
  @Input()
  set css(val:string[]|string){
    this._css = val?((typeof val=='object'&&typeof val.length=='number')?val:(typeof val=='string'?val.split(' '):[])):[];
    if (this.el && this.el.nativeElement && this.renderer){
      this._css.filter(c=>!!c&&c.trim().length>0).forEach(c=>this.renderer.addClass(this.el.nativeElement,c));
    }
  }
  @Input()
  set invalid(val:boolean){
    if (this.el && this.el.nativeElement && this.renderer){
      if (val){
        this._css.forEach(()=>this.renderer.addClass(this.el.nativeElement,'invalid'));
      } else {
        this._css.forEach(()=>this.renderer.removeClass(this.el.nativeElement,'invalid'));
      }
    }
  }
  _styles:NbStyle= {};
  @Input()
  set styles(val:NbStyle){
    this._styles = val?val:{};
    if (this.el && this.el.nativeElement && this.renderer && this._css){
      Object.keys(this._styles).forEach(p=>{
        this.renderer.setStyle(this.el.nativeElement,p,this._styles[p]);
      });
    }
  }
  constructor(private el: ElementRef,private renderer: Renderer2) {}
}


export class NbStyle{
  [key:string]:string
}
